export * from './HostedPage';
